import { name } from './name';
import { general } from './general';
import { branch } from './branch';
import { email } from './email';
import { telephone } from './telephone';
import { text } from './text';
import { datecontrol } from './datecontrol';
import { textarea } from './textarea';
import { location } from './location';
import { daterange } from './daterange';
import { country } from './country';
import { radio } from './radio';
import { checkboxgroup } from './checkboxgroup';

export const collection = (items = [], addendum = null) => {
  const b = addendum ? branch(addendum) : null;
  return general('collection', {
    items,
    branch: b,
  });
};

export const telephoneCollection = function (data = {}) {
  return ((data || {}).items || []).map((x) => {
    const item = x.Item || {};
    return {
      Item: {
        Has: branch(item.Has),
        Telephone: telephone(item.Telephone),
      },
    };
  });
};

export const emailCollection = function (data = {}) {
  return ((data || {}).items || []).map((x) => {
    const item = x.Item || {};
    return {
      Item: {
        Has: branch(item.Has),
        Email: email(item.Email),
      },
    };
  });
};

export const internationalPassportCollection = function (data = {}) {
  return ((data || {}).items || []).map((x) => {
    const item = x.Item || {};
    return {
      Item: {
        Has: branch(item.Has),
        InfoGrab: branch(item.InfoGrab),
        InfoGrabExplain: textarea(item.InfoGrabExplain),
        Threatened: branch(item.Threatened),
        ThreatenedExplain: textarea(item.ThreatenedExplain),
        ElicitInfo: branch(item.InfoGrab),
        ElicitInfoExplain: textarea(item.InfoGrabExplain),
        Interest: branch(item.Interest),
        InterestExplain: textarea(item.InterestExplain),
        SecurityIncidents: branch(item.SecurityIncidents),
        SecurityIncidentsExplain: textarea(item.SecurityIncidentsExplain),
        ForeignContact: branch(item.ForeignContact),
        ForeignContactExplain: textarea(item.ForeignContactExplain),
        PoliceEncounters: branch(item.PoliceEncounters),
        PoliceEncountersExplain: textarea(item.PoliceEncountersExplain),
        SearchedExplain: textarea(item.SearchedExplain),
        Searched: branch(item.Searched),
        WhyTravel: textarea(item.WhyTravel),
        WhenTraveled: daterange(item.WhenTraveled),
        CountryTraveledTo: location(item.CountryTraveledTo),
        Days: radio(item.Days),
        Purpose: checkboxgroup(item.Purpose),
      },
    };
  });
};

export const foreignPassportCollection = function (data = {}) {
  return ((data || {}).items || []).map((x) => {
    const item = x.Item || {};
    return {
      Item: {
        Has: branch(item.Has),
        International: collection(internationalPassportCollection(item.International)),
        DocumentNum: text(item.DocumentNum),
        NameUsed: name(item.NameUsed),
        IssueLocation: location(item.IssueLocation),
        ExpirationDate: datecontrol(item.ExpirationDate),
        Access: branch(item.Access),
        IssueDate: datecontrol(item.IssueDate),
        ForeignCountry: country(item.ForeignCountry),
        DocIntentIntl: branch(item.DocIntentIntl),
        DocIntentIntlExplain: textarea(item.DocIntentIntlExplain),
        DocIntent: branch(item.DocIntent),
        DocIntentExplain: textarea(item.DocIntentExplain),
      },
    };
  });
};
